import {
    TextInput,
} from 'react-admin';
import MaterialUIInput from "@material-ui/core/Input";import React, {Fragment} from "react";
import CheckInStore from "../stores/CheckInStore2";
import simpleMemoize from "../../framework/util/forms/SimpleMemoize";
import {TextField} from '@material-ui/core';

/**
 * A text field for scanning in operator ids.
 * Loads the checked in operator by default.
 * On change, validates that the new ID exists
 * Validates required and existing user.
 *
 * @returns {null|*}
 * @constructor
 */
const CheckedInOperatorText = (props) => {

    const [checkInInfo, setCheckInInfo] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const [textValue, setTextValue] = React.useState();

    /**
     * Load the checked in operator
     *
     * @returns {Promise<void>}
     */
    async function loadDefaultData() {
        const checkedInUser = await new CheckInStore().read();
        setCheckInInfo(checkedInUser.data);
        setLoading(false);
    }

    React.useEffect(() => {
        loadDefaultData();
    }, []);

    // This is important to enable the default value
    // If the field loads before it, default value
    // is ignored
    if (loading)
        return null;

    /**
     * Validates that a scanned id is valid and exists in the people
     * database
     *
     * @param value
     * @param allValues
     * @returns {string|*[]}
     */
    const validatePerson = async (value, allValues) => {
        if (!value) {
            return 'Required';
        }

        try {
            const checkedInUser = await new CheckInStore().loadDataFromPersonId(value);
            return;
        }
        catch(error) {
            console.log(error);
            return "Not found";
        }

        return;
    };


    /**
     * Update the helper text to show the current operator
     * @param evt
     * @returns {Promise<void>}
     */
    const onChanged =  simpleMemoize(async (evt)=> {
        try {
            const value = evt.target.value;
            setTextValue(value);
            const data = await new CheckInStore().loadDataFromPersonId(value);
            console.log('Loaded operator', data);
            setCheckInInfo(data);
        }
        catch(error) {
            console.log(error)
            setCheckInInfo(null);
        }
    });


    var helperText;
    const checkedOutMsg = 'Checked out, scan or enter a valid id';

    if (textValue && checkInInfo == null) {
        helperText = checkedOutMsg
    }
    else if (checkInInfo && checkInInfo.firstName) {
        helperText = checkInInfo.firstName + ' ' + checkInInfo.lastName;
    }
    else {
        helperText = checkedOutMsg;
    }


    const label = props.label ? props.label : 'Operator Id';
    const defaultValue = props.defaultValue ? props.defaultValue : (checkInInfo ? checkInInfo.personId: null);
    const source = props.source ? props.source : 'personId';
    const variant = 'outlined';

    if (props.useReactHookForms) {
        return (
            <TextField
                size={"small"}
                label={label}
                name={props.name}
                defaultValue={defaultValue}
                source={source}
                onFocus={event => {
                    setTimeout(event.target.select.bind(event.target), 1);
                }}
                onChange={onChanged}
                variant={variant}
                disabled={props.disabled}
                inputRef={props.inputRef}
                error={props.error}
                helperText={props.error ? props.errorMessage : helperText}
                fullWidth={props.fullWidth}
            ></TextField>
        );
    }
    else {
        return (
            <TextInput
                label={label}
                defaultValue={defaultValue}
                validate={validatePerson}
                source={source}
                required={true}
                onFocus={event => {
                    setTimeout(event.target.select.bind(event.target), 1);
                }}
                onChange={onChanged}
                helperText={helperText}
                variant={variant}
                disabled={props.disabled}
                fullWidth={props.fullWidth}
            ></TextInput>
        );
    }
}

export default CheckedInOperatorText;
